export function getdata() {
	var obj = {
		province: [{
				"name": "安徽",
				"code": "AH"
			},
			{
				"name": "陕西",
				"code": "SHANXI"
			},
			{
				"name": "辽宁",
				"code": "LN"
			},
			{
				"name": "江苏",
				"code": "JS"
			},
			{
				"name": "新疆",
				"code": "XJ"
			},
			{
				"name": "湖北",
				"code": "HUBEI"
			},
			{
				"name": "北京",
				"code": "BJ"
			},
			{
				"name": "四川",
				"code": "SC"
			}
		],
		searchlist: [{
				prop: "type",
				label: '业务方类型',
				type: "select",
				selectval: [
					// label: "客户 ",
					// value: "0"
				]
			},
			{
				prop: "supplierTaxNumber",
				label: '业务方税号',
				type: "input",
			},
			// {
			// 	prop: "supplierCode",
			// 	label: '业务方代码',
			// 	type: "input"
			// },
			{
				prop: "supplierRiskTaxViolation",
				label: '重大税收违法风险',
				type: "select",
				selectval: [{
						label: "高 ",
						value: "2"
					},
					{
						label: "中 ",
						value: "1"
					},
					{
						label: "无 ",
						value: "0"
					}
				]
			},
			{
				prop: "supplierRiskManagement",
				label: '经营异常风险',
				type: "select",
				selectval: [{
						label: "高 ",
						value: "2"
					},
					{
						label: "中 ",
						value: "1"
					},
					{
						label: "无 ",
						value: "0"
					}
				]
			},
			{
				prop: "supplierRiskExecuted",
				label: '严重违法风险',
				type: "select",
				selectval: [{
						label: "高 ",
						value: "2"
					},
					{
						label: "中 ",
						value: "1"
					},
					{
						label: "无 ",
						value: "0"
					}
				]
			},
			{
				prop: "customBlacklist",
				label: '自定义灰名单',
				type: "select",
				selectval: [{
						label: "停用",
						value: "0"
					},
					{
						label: "启用 ",
						value: "1"
					}
				]
			},
			{
				prop: "supplierName",
				label: '业务方名称',
				type: "input",
			},
			{
				prop: "lastQueryTime",
				label: '最新风险查询时间',
				type: "realdate",
				valueformat: "yyyy-MM-dd",
			},
			{
				prop: "includeTime",
				label: '灰名单列入时间',
				type: "realdate",
				valueformat: "yyyy-MM-dd",
			},
			// {
			// 	prop: "period",
			// 	label: '操作人',
			// 	type: "input",
			// },
			{
				prop: "createBy",
				label: '操作人',
				type: "input",
			},
		],
		searchdata: {

		},
		headDatags: [{
			title: "公司代码",
			prop: "companyCode",
			width: "100"
		}, {
			title: "公司名称",
			prop: "name",
			width: "200"

		}],
		SGRRheadData: [{
			title: "公司代码",
			prop: "text1",
			width: "100"
		}, {
			title: "公司名称",
			prop: "text2",
			width: "200"
		}],
		headData: [{
				title: "业务方税号",
				prop: "supplierTaxNumber",
				custom: true,
				width: "100"
			},
			// {
			// 	title: "业务方代码",
			// 	prop: "supplierCode",
			// 	width: "100"
			// },
			{
				title: "业务方名称",
				prop: "supplierName",
				custom: true,
				width: 160,
				// custom: true
			},
			{
				title: "业务方类型",
				prop: "type",
				custom: true,
				width: "100",
				//  custom: true
			},
			{
				title: "业务方来源",
				prop: "supplierSource",
				width: "100",
				custom: true
			},
			{
				title: "经营异常风险",
				prop: "supplierRiskManagement",
				width: "110",
				custom: true
			},
			{
				title: "严重违法风险",
				prop: "supplierRiskExecuted",
				width: "110",
				custom: true
			},
			{
				title: "重大税收违法风险",
				prop: "supplierRiskTaxViolation",
				width: "140",
				custom: true
			},
			{
				title: "最新风险查询时间",
				prop: "lastQueryTime",
				width: 160,
				custom: true,

			},
			{
				title: "自定义灰名单",
				prop: "customBlacklist",
				width: "110",
				custom: true
			},
			{
				title: "列入时间",
				prop: "includeTime",
				width: 160,
				custom: true,
			},
			// {
			// 	title: "银行",
			// 	prop: "bank",
			// 	width: 80
			// },
			// {
			// 	title: "地址",
			// 	prop: "address",
			// 	width: 160,
			// 	align: "left"
			// },
			// {
			// 	title: "邮编",
			// 	prop: "zipCode",
			// 	width: 160,
			// 	align: "left"
			// },
			// {
			// 	title: "联系人",
			// 	prop: "contacts",
			// 	width: "100"
			// },
			// {
			// 	title: "联系电话",
			// 	prop: "contactsNumber",
			// 	width: 160,
			// 	align: "left"
			// },
			// {
			// 	title: "联系人邮箱",
			// 	prop: "contactsEmail",
			// 	width: 160,
			// 	align: "left"
			// },
			// {
			// 	title: "快递地址",
			// 	prop: "expressAddress",
			// 	width: 160,
			// 	align: "left"
			// },
			{
				title: "业务风险详情",
				prop: "test2",
				width: "200",
				custom: true,
				fixed: "right"
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		formlist: [{
				prop: "supplierName",
				label: "业务方名称",
				type: "input",
				width: "300px",
			},

			{
				prop: "supplierTaxNumber",
				label: "业务方税号",
				type: "input",
				width: "300px",
			}
		],
		formdata: {
			supplierName: "",
			supplierTaxNumber: "",


		},
		formlisthmd: [{
				prop: "isBlack",
				label: "自定义灰名单",
				type: "radio",
				radioval: [{
						label: "移入",
						value: "1"
					},
					{
						label: "移出",
						value: "0"
					}
				]
			},
			{
				prop: "includeReason",
				label: "移入/移出原因",
				type: "textarea",
				width: "280px",
			},
		],
		formdatahmd: {
			isBlack: "1",
			includeReason: ""
		}
	}
	return obj
}
